/* eslint-disable react/jsx-pascal-case */
import {
  TCustomCheckoutComponentItem,
  // TCustomCheckoutComponentType,
  isCheckoutItem,
  isStopWatchItem,
  isLayout2_3Item,
  isListItem,
  isTextItem,
  isImageItem,
  isEmptyItem,
} from "../../core/types/CustomCheckout";
import StopWatchWidget from "../Checkout/StopWatch";
import CheckoutComponenetList from "./CheckoutComponentList";
import CheckoutEmpty from "./CheckoutEmpty";
import CheckoutHeader from "./CheckoutHeader";
import CheckoutImage from "./CheckoutImage";
import CheckoutLayout2_3 from "./CheckoutLayout2_3";
import CheckoutPlaceholder from "./CheckoutPlaceholder";
import CheckoutText from "./CheckoutText";

export interface ICheckoutComponenetWidgetProps {
  item: TCustomCheckoutComponentItem;
  parentList: TCustomCheckoutComponentItem[];
}

const CheckoutComponenetWidget = ({ item, parentList }: ICheckoutComponenetWidgetProps) => {
  if (isCheckoutItem(item)) {
    return <CheckoutPlaceholder />;
  }
  if (isStopWatchItem(item)) {
    return (
      <StopWatchWidget
        initialTime={item.milleseconds ?? 900000}
        text={item.title}
        textFinished={item.subtitle}
        backgroundColor={item.sx.backgroundColor}
        color={item.sx.color}
      />
    );
  }
  if (isLayout2_3Item(item)) {
    return <CheckoutLayout2_3 item={item} parentList={parentList} />;
  }
  if (isListItem(item)) {
    return <CheckoutComponenetList listOverride={item.children} />;
  }
  if (isTextItem(item)) {
    return <CheckoutText text={item.title} />;
  }
  if (isImageItem(item)) {
    return <CheckoutImage imageUrl={item.imageUrl} alt={item.imageName ?? item.id} />;
  }
  if (isEmptyItem(item)) {
    return <CheckoutEmpty />;
  }
  // Default: none type (header)
  return <CheckoutHeader height={item.sx.height} />;
};

export default CheckoutComponenetWidget;
